module.exports = __webpack_public_path__ + "static/media/penn_storage_logo_inverted.99f1549d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/penn_storage_logo_inverted.svg
// module id = 323
// module chunks = 0